import React from 'react'
import {FaEnvelope, FaPhoneAlt} from 'react-icons/fa'

const contact = () => {
    return (
        <section className="h-auto mx-10 font-quicksand">
            <div>
                <h2 className="text-3xl font-semibold font-quicksand my-20 text-center text-primary block"> <span className="p-2 canvas-hover"> Contact me </span> </h2>

                <span className="flex flex-col md:flex-row justify-evenly mb-20">
                    <a className="p-2 canvas-hover" href="mailto:paragmahale36@gmail.com"> <FaEnvelope className="inline-block text-xl"/> : paragmahale36@gmail.com </a> <a className="p-2 canvas-hover" href="tel:+917057634075"> <FaPhoneAlt className="inline-block text-xl"/> : +91&nbsp;7057634075</a> 
                </span>
                
            </div>
        </section>
    )
}

export default contact
